module.exports = __webpack_public_path__ + "img/logo-devtools.b82e0b54.png";